module.exports = __webpack_public_path__ + "static/media/kar1.16847c27.jpg";